export default __webpack_public_path__ + "locales/cs/SendInviteDialog.json?hash=c75c51b3fbb7b29d034c861f9e0fe4d7";